class SonicImageModal extends HTMLElement {
    constructor(){
        super();

        this.imageItems = document.querySelectorAll('[id^="SonicImages-"]');
        this.modal_image_wrapper = this.querySelector('[id=SonicModalImageWrapper]');
        this.modal_image = this.querySelector('[id=SonicModalImage]');

        if(!this.modal_image_wrapper || !this.modal_image) return;

        this.imageItems.forEach((item) => {
            item.addEventListener("click",() => {
                this.show(item.src,item.naturalWidth);
                this.modal_image_wrapper.focus();
            });
        });

        this.addEventListener("click",() => {
            this.hide();
        });
    }

    hide(){
        const html = document.querySelector("html");
        if(html){
            html.style.overflow = "auto";
        }
        this.removeAttribute("open");
    }

    show(src,width){
        const html = document.querySelector("html");
        if(html){
            html.style.overflow = "hidden";
        }
        this.modal_image.setAttribute("src",src);
        this.modal_image.setAttribute("width",width);
        this.focus();
        this.setAttribute("open","");
    }
}
customElements.define("sonic-image-modal", SonicImageModal);